import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SearchBox() {
  const [query, setQuery] = useState('');
  const [focused, setFocused] = useState(false);
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = query.trim();
    if (trimmed) {
      const searchUrl = `https://www.baidu.com/s?wd=${encodeURIComponent(trimmed)}`;
      window.open(searchUrl, '_blank');
    }
  };

  return (
    <form onSubmit={handleSearch} className="w-full max-w-2xl mx-auto">
      <div
        className={`flex items-center gap-3 bg-background-50 rounded-2xl px-5 py-3.5 border-2 transition-all duration-200 ${
          focused
            ? 'border-primary-400 ring-4 ring-primary-100/50'
            : 'border-background-200 hover:border-background-300'
        }`}
      >
        <i className="ri-search-line text-xl text-foreground-400"></i>
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          placeholder="搜索网站、文章或直接跳转..."
          className="flex-1 bg-transparent outline-none text-sm text-foreground-900 placeholder:text-foreground-400"
        />
        {query && (
          <button
            type="button"
            onClick={() => setQuery('')}
            className="w-6 h-6 flex items-center justify-center rounded-full bg-foreground-200/50 text-foreground-500 hover:bg-foreground-300/50 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-xs"></i>
          </button>
        )}
        <button
          type="submit"
          className="px-5 py-2 bg-primary-500 text-background-50 rounded-xl text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          搜索
        </button>
      </div>
    </form>
  );
}